export const isNullOrEmpty = (value: any) => value === '' || value == null || value == undefined;